import { render, staticRenderFns } from "./UpdateUserDocumentComponent.vue?vue&type=template&id=24e7d4d9&"
import script from "./UpdateUserDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateUserDocumentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports